import React, { Component } from "react";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import MasterPromoH2Header from "./masterPromoH2Header";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import * as R from "ramda";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import TabJob from "./tabJob";
import TabPart from "./tabPart";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class MasterPromoH2Modifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      tableColumn: [],
      jobList: [],
      partList: [],
      jobData: [],
      partData: [],
      dataArea: [],
      file: null,
      selectedData: null,
      selectedIndex: null,
      errors: {},
      sortOrder: { name: "kodeVariant", direction: "asc" },
      saveAlert: false,
      activeTab: 0,
    };
    this.fileInputRef = React.createRef();
  }

  componentDidMount = async () => {
    let viewOnly = this.props.activityType === ACTIVITY_TYPE.VIEW;
    this.fetchDataArea();

    if (this.props.initialValues) {
      this.handleTriggerLoading();
      await this.fetchData();
      this.handleTriggerLoading();
    }

    if (
      this.props.activityType === ACTIVITY_TYPE.CREATE ||
      this.props.activityType === "COPY"
    ) {
      this.handleTriggerLoading();
      await this.fetchDataPreviewId();
      if (this.props.activityType === ACTIVITY_TYPE.CREATE)
        this.props.setValue("dataUnit", []);
      this.handleTriggerLoading();
    }
  };

  componentDidUpdate = () => {};

  fetchDataArea = async () => {
    const dataCabang = this.props.dataCabang;
    const listIdWilayah = [
      ...new Set(
        dataCabang.map((item) => item.idWilayah).filter(Boolean)
      ),
    ];

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllByListKey,
      menuName: `Master Promo H2`,
      setError: this.props.setError,
      args: listIdWilayah,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataArea: res.data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        ),
      }));
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleBeforeSubmit = () => {
    const { controls, setError } = this.props;
    const formData = this.prepareFormData();
    const errors = this.validate(controls, formData);
    console.log(errors);

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      Object.entries(errors).forEach(([key, message]) => {
        if (key !== "hasPopupError" && typeof setError === "function") {
          setError(key, message);
        }
      });
      return;
    }

    this.setState({ formData }, () => {
      this.handleSaveSubmitAlertModalVisibility(
        "Apakah anda yakin ingin menyimpan data ini?"
      );
    });
  };

  // handleSubmit = () => {
  //   const { formData } = this.state;
  //   this.handleSaveSubmitAlertModalVisibility();

  //   if (formData) {
  //     this.props.onSubmit(formData);
  //   }
  // };

  handleSubmit = () => {
    const { formData } = this.state;
    this.handleSaveSubmitAlertModalVisibility();

    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    const cleanUuidId = (list) =>
      Array.isArray(list)
        ? list.map((item) => ({
            ...item,
            id: uuidRegex.test(item.id) ? null : item.id,
          }))
        : list;

    const cleanedData = {
      ...formData,
      job: cleanUuidId(formData.job),
      part: cleanUuidId(formData.part),
    };

    if (cleanedData) {
      this.props.onSubmit(cleanedData);
    }
  };

  prepareFormData = () => {
    const { controls, activityType } = this.props;
    const { jobList, partList } = this.state;
    const isCreate = activityType === "CREATE";

    const getValue = (key) => controls[key]?.value ?? null;

    const jobListPayload = (jobList || []).map((job) => ({
      id: isCreate ? null : job.id ?? null,
      parentPromoId: isCreate ? null : job.parentPromoId ?? null,
      promoJobId: isCreate ? null : job.promoJobId ?? null,
      unit: job.unit ?? null,
      serviceCode: job.serviceCode ?? null,
      discountValue: parseFloat(job.discountValue ?? 0),
    }));

    const partListPayload = (partList || []).map((part) => ({
      id: isCreate ? null : part.id ?? null,
      parentPromoId: isCreate ? null : part.parentPromoId ?? null,
      promoPartId: isCreate ? null : part.promoPartId ?? null,
      unit: part.unit ?? null,
      partCode: part.kodePart ?? null,
      discountValue: parseFloat(part.discountValue ?? 0),
    }));

    const cabangCode = (getValue("cabangCode") || []).map((c) => c.value);

    const formData = {
      id: isCreate ? null : getValue("id"),
      promoId: isCreate ? null : getValue("promoServicePartId"),
      promoServicePartName: getValue("promoServicePartName"),
      promoTypeLocation: getValue("promoTypeLocation"),
      idWilayah: getValue("idWilayah")?.value ?? null,
      combinePromo: getValue("combinePromo"),
      promoStartDate: getValue("promoStartDate"),
      promoEndDate: getValue("promoEndDate"),
      promoHasGracePeriode: getValue("promoHasGracePeriode"),
      promoGracePeriode: parseInt(getValue("promoGracePeriode") || 0),
      promoAllJob: getValue("promoAllJob"),
      promoAllJobUnit: getValue("promoAllJobUnit")?.value ?? null,
      promoAllJobValue: parseFloat(getValue("promoAllJobValue") ?? 0),
      promoAllPart: getValue("promoAllPart"),
      promoAllPartUnit: getValue("promoAllPartUnit")?.value ?? null,
      promoAllPartValue: parseFloat(getValue("promoAllPartValue") ?? 0),
      cabangCode,
      job: jobListPayload,
      part: partListPayload,
    };

    if (formData.promoAllJob) formData.job = [];
    if (formData.promoAllPart) formData.part = [];

    return formData;
  };

  validate = (controls, formData) => {
    const newErrors = {};
    let showPopup = false;

    for (const [key, data] of Object.entries(controls)) {
      const errorMsg = this.validateEmptyValue(data);
      if (errorMsg) {
        newErrors[key] = errorMsg;
      }
    }

    const promoHasGracePeriode = controls.promoHasGracePeriode?.value;
    const promoGracePeriode = controls.promoGracePeriode?.value;
    const promoStartDate = controls.promoStartDate?.value;
    const promoEndDate = controls.promoEndDate?.value;

    if (!promoGracePeriode && !promoHasGracePeriode) {
      newErrors["promoGracePeriode"] = "Field belum diisi";
    }

    if (!promoStartDate && !promoHasGracePeriode) {
      newErrors["promoStartDate"] = "Field belum diisi";
    }

    if (!promoEndDate && !promoHasGracePeriode) {
      newErrors["promoEndDate"] = "Field belum diisi";
    }

    const promoTypeLocation = controls.promoTypeLocation?.value;
    if (promoTypeLocation === "CABANG" && !controls.cabangCode?.value?.length) {
      newErrors["cabangCode"] = "Field belum diisi";
    }

    if (promoTypeLocation === "WILAYAH" && !controls.idWilayah?.value) {
      newErrors["idWilayah"] = "Field belum diisi";
    }

    const jobEmpty = !formData.promoAllJob && formData.job.length === 0;
    const partEmpty = !formData.promoAllPart && formData.part.length === 0;

    if (jobEmpty && partEmpty) {
      newErrors["job"] = "Job atau Part harus diisi minimal satu";
      newErrors["part"] = "Job atau Part harus diisi minimal satu";
      showPopup = true;
    }

    if (controls.promoAllPart?.value) {
      const unit = controls.promoAllPartUnit?.value;
      const value = controls.promoAllPartValue?.value;

      if (!unit) newErrors["promoAllPartUnit"] = "Field wajib diisi";
      if (value == null || value === "" || Number(value) === 0)
        newErrors["promoAllPartValue"] = "Field wajib diisi";
    }

    if (controls.promoAllJob?.value) {
      const unit = controls.promoAllJobUnit?.value;
      const value = controls.promoAllJobValue?.value;

      if (!unit) newErrors["promoAllJobUnit"] = "Field wajib diisi";
      if (value == null || value === "" || Number(value) === 0)
        newErrors["promoAllJobValue"] = "Field wajib diisi";
    }

    if (showPopup) {
      this.handleSaveAlertModalVisibility("Terdapat data yang belum lengkap");
    }

    return newErrors;
  };

  validateEmptyValue(data) {
    if (R.and(data.mandatory, R.or(!data.value, R.isEmpty(data.value)))) {
      return "Field belum diisi";
    }

    return null;
  }

  fetchData = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getDetailMasterPromoH23,
      setError: this.props.setError,
      menuName: "Master Promo",
      args: contructQueryParam({ id: this.props.initialValues?.id }),
    });

    if (res.ok && res.data.status === HttpStatus.FAILED) {
      this.props.onClickClose();
    }
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const { data } = res.data;

      const mapUnitToDDL = (unit) => {
        if (!unit) return null;
        if (typeof unit === "object") return unit;

        switch (unit) {
          case "AMOUNT":
            return { value: "AMOUNT", label: "Currency" };
          case "PERCENTAGE":
            return { value: "PERCENTAGE", label: "Percentage" };
          default:
            return { value: unit, label: unit };
        }
      };

      let wilayahDDL = null;

      if (data?.idWilayah) {
        const wilayah = this.state.dataArea?.find(
          (item) => item.value === data.idWilayah
        );

        if (wilayah) {
          wilayahDDL = {
            value: wilayah.value,
            label: wilayah.label,
          };
        } else {
          wilayahDDL = {
            value: data.idWilayah,
            label: data.idWilayah,
          };
        }
      }

      this.props.setValue("id", data?.id);
      this.props.setValue("promoServicePartId", data?.promoServicePartId);
      this.props.setValue("promoServicePartName", data?.promoServicePartName);
      this.props.setValue("promoTypeLocation", data?.promoTypeLocation);
      this.props.setValue("idWilayah", wilayahDDL);
      this.props.setValue("combinePromo", data?.combinePromo);
      this.props.setValue("promoStartDate", data?.promoStartDate);
      this.props.setValue("promoEndDate", data?.promoEndDate);
      this.props.setValue("promoHasGracePeriode", data?.promoHasGracePeriode);
      this.props.setValue("promoGracePeriode", data?.promoGracePeriode);
      this.props.setValue("promoAllJob", data?.promoAllJob);
      this.props.setValue(
        "promoAllJobUnit",
        mapUnitToDDL(data?.promoAllJobUnit)
      );
      this.props.setValue("promoAllJobValue", data?.promoAllJobValue);
      this.props.setValue("promoAllPart", data?.promoAllPart);
      this.props.setValue(
        "promoAllPartUnit",
        mapUnitToDDL(data?.promoAllPartUnit)
      );
      this.props.setValue("promoAllPartValue", data?.promoAllPartValue);
      this.props.setValue("job", data?.job);
      this.props.setValue("part", data?.part);

      let listCabang = [];
      if (!data?.idWilayah) {
        listCabang =
          data?.cabangCode?.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          ) || [];
      }
      this.props.setValue("cabangCode", listCabang);

      const jobList = (data?.job || []).map((item) => ({
        id: item.id,
        promoJobId: item.promoJobId,
        serviceCode: item.service?.serviceCode || "",
        serviceName: item.service?.serviceName || "",
        serviceCategory: item.service?.serviceCategory?.value || "",
        kodeVariant: item.service?.variant?.kodeVariant || "",
        namaVariant: item.service?.variant?.namaVariant || "",
        unit: item.unit || "",
        discountValue: item.discountValue || 0,
      }));

      const partList = (data?.part || []).map((item) => ({
        id: item.id,
        promoPartId: item.promoPartId,
        kodePart: item.part?.kodePart || "",
        partName: item.part?.partName || "",
        partCategory: item.part?.partCategory?.value || "",
        unit: item.unit || item.part?.satuan?.value || "",
        discountValue: item.discountValue || 0,
      }));

      this.setState({
        jobData: jobList,
        partData: partList,
        jobList: JSON.parse(JSON.stringify(jobList)),
        partList: JSON.parse(JSON.stringify(partList)),
      });
    }
  };

  fetchDataPreviewId = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPreviewIdMasterPromoH23,
      setError: this.props.setError,
      menuName: "Master Promo H23",
      args: null,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.props.setValue("promoServicePartId", res.data.data);
      this.props.setValue("promoName", null);
      this.props.setValue("id", null);
    }
  };

  handleValidateSubmit = async () => {
    if (this.state.file) {
      this.handleTriggerLoading();
      const formData = new FormData();
      formData.append(
        "promoType",
        this.props.controls?.promoType?.value?.value?.toString()?.toUpperCase()
      );
      formData.append("file", this.state.file);

      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").uploadExcelDataMasterPromo,
        setError: this.props.setError,
        menuName: "Master Promo",
        args: formData,
      });

      if (res.ok && res.data.status === HttpStatus.FAILED) {
        this.handleTriggerLoading();
        document.getElementById("inputFile").value = "";
        this.setState({ file: null });
        return;
      }

      if (res.ok) {
        const prevDataUnit = this.props.controls.dataUnit.value;
        const listDataUnit = res.data.data?.map((item) => {
          const { warna, variant, credit, ...filtered } = item;
          return {
            dataVariant: {
              kodeVariant: variant?.kodeVariant,
              namaVariant: variant?.namaVariant,
            },
            dataWarna: {
              id: warna?.warnaResponseDTO?.id,
              kodeWarna: warna?.warnaResponseDTO?.kodeWarna,
              namaWarnaKomersil: warna?.warnaResponseDTO?.namaWarnaKomersil,
            },
            ...filtered,
            ...credit,
          };
        });

        prevDataUnit.push(...listDataUnit);
        this.props.setValue("dataUnit", prevDataUnit);
        document.getElementById("inputFile").value = "";
        this.setState({ file: null });
        this.handleTriggerLoading();
        this.handleUploadVisibility();
      }
    }
  };

  onClickClose = () => {
    this.props.onClickClose();
    this.props.setValue("dataUnit", []);
  };

  handleDataChange = (type, updatedData) => {
    const key = type === "job" ? "jobList" : "partList";

    this.setState(
      (prev) => {
        const map = new Map();
        updatedData.forEach((item) => map.set(item.id ?? item.tempId, item));
        return { [key]: Array.from(map.values()) };
      },
      () => {
        this.props.setValue(type, this.state[key]);
      }
    );
  };

  handleSaveAlertModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      saveAlert: !prevState.saveAlert,
    }));
  };

  handleSaveSubmitAlertModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      saveSubmitAlert: !prevState.saveSubmitAlert,
    }));
  };

  handleTabChange = (index) => {
    this.setState({
      activeTab: index
    });
  };

  render() {
    return (
      <SimpleModal
        title="Master Promo Detail"
        visible={this.props.visible}
        onClickClose={this.onClickClose}
        content={
          <ModalContainer>
            <MasterPromoH2Header
              {...this.props}
              errors={this.state.errors}
              triggerLoading={this.handleTriggerLoading}
              dataArea={this.state.dataArea}
            />

            <Tabs
              forceRenderTabPanel
              selectedIndex={this.state.activeTab}
              onSelect={(index) => this.handleTabChange(index)}
            >
              <TabList>
                <Tab>JOB</Tab>
                <Tab>PART</Tab>
              </TabList>
              <TabPanel>
                <TabJob
                  key={`job-${this.state.activeTab}`}
                  {...this.props}
                  data={this.state.jobList}
                  errors={this.state.errors}
                  onDataChange={this.handleDataChange}
                  triggerLoading={this.handleTriggerLoading}
                />
              </TabPanel>
              <TabPanel>
                <TabPart
                  key={`part-${this.state.activeTab}`}
                  {...this.props}
                  data={this.state.partList}
                  errors={this.state.errors}
                  onDataChange={this.handleDataChange}
                  triggerLoading={this.handleTriggerLoading}
                />
              </TabPanel>
            </Tabs>

            <FlexView style={{ justifyContent: "end", marginTop: "10px" }}>
              {this.props.activityType === ACTIVITY_TYPE.VIEW ? (
                <SimpleButton text="Keluar" onClick={this.props.onClickClose} />
              ) : (
                <>
                  <SimpleButton
                    text="Simpan"
                    onClick={this.handleBeforeSubmit}
                  />
                </>
              )}
            </FlexView>

            {this.state.saveAlert && (
              <SimpleAlert
                title={"Information"}
                content={
                  <div>
                    <p>
                      {this.state.warningMessage}
                      <br />
                      Mohon periksa kembali.
                    </p>
                  </div>
                }
                visible={this.state.saveAlert}
                onClickClose={this.handleSaveAlertModalVisibility}
                additionalButtons={
                  <SimpleButton
                    type="button"
                    text="OK"
                    onClick={() => this.handleSaveAlertModalVisibility()}
                  />
                }
              />
            )}

            {this.state.saveSubmitAlert && (
              <SimpleAlert
                title={"Information"}
                content={
                  <div>
                    <p>{this.state.warningMessage}</p>
                  </div>
                }
                visible={this.state.saveSubmitAlert}
                onClickClose={this.handleSaveSubmitAlertModalVisibility}
                additionalButtons={
                  <FlexView
                    vAlignContent="center"
                    style={{ alignItems: "end" }}
                  >
                    <SimpleButton
                      type="button"
                      text="Batal"
                      onClick={() =>
                        this.handleSaveSubmitAlertModalVisibility()
                      }
                    />
                    <SimpleButton
                      type="button"
                      text="OK"
                      onClick={() => this.handleSubmit()}
                    />
                  </FlexView>
                }
              />
            )}

            {this.state.loading && (
              <SimpleLoadingOverlay active={this.state.loading} />
            )}
          </ModalContainer>
        }
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withFormGroup(MasterPromoH2Modifying));
